import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProducts } from '../services/api';
import { Product } from '../types';
import ProductCard from '../components/ProductCard';
import './ProductsPage.css';

const ProductsPage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await getProducts();
        setProducts(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Nem sikerült betölteni a termékeket. Kérjük, próbáld újra később.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // For demo purposes, if API is not available, use mock data
  useEffect(() => {
    if (error) {
      // Mock data for demonstration
      const mockProducts: Product[] = [
        {
          _id: '1',
          name: 'Kovászos kenyér',
          description: 'Hagyományos kovászos kenyér, hosszú érleléssel készítve.',
          price: 950,
          imageUrl: 'https://images.unsplash.com/photo-1549931319-a545dcf3bc73?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          available: true
        },
        {
          _id: '2',
          name: 'Magvas cipó',
          description: 'Többféle maggal dúsított cipó, ropogós héjjal.',
          price: 750,
          imageUrl: 'https://images.unsplash.com/photo-1586444248902-2f64eddc13df?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          available: true
        },
        {
          _id: '3',
          name: 'Sajtos pogácsa',
          description: 'Omlós, sajtos pogácsa, friss tejföllel készítve.',
          price: 250,
          imageUrl: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          available: true
        },
        {
          _id: '4',
          name: 'Kakaós csiga',
          description: 'Puha, vajas tésztából készült kakaós csiga.',
          price: 350,
          imageUrl: 'https://images.unsplash.com/photo-1509365465985-25d11c17e812?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          available: true
        },
        {
          _id: '5',
          name: 'Diós kalács',
          description: 'Hagyományos diós kalács, gazdag töltelékkel.',
          price: 1200,
          imageUrl: 'https://images.unsplash.com/photo-1586444248902-2f64eddc13df?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          available: true
        },
        {
          _id: '6',
          name: 'Rozskenyér',
          description: 'Egészséges rozskenyér, magas rosttartalommal.',
          price: 850,
          imageUrl: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
          available: true
        }
      ];
      
      setProducts(mockProducts);
    }
  }, [error]);

  return (
    <div className="products-page">
      <div className="products-header">
        <h1>Termékeink</h1>
        <p>Válassz kézműves péktermékeink közül</p>
      </div>
      
      {loading ? (
        <div className="loading">Termékek betöltése...</div>
      ) : (
        <>
          {products.length > 0 ? (
            <div className="products-grid">
              {products.map((product) => (
                <div className="product-item" key={product._id}>
                  <ProductCard product={product} />
                </div>
              ))}
            </div>
          ) : (
            <div className="no-products">
              <p>Jelenleg nincsenek elérhető termékek.</p>
              <Link to="/" className="btn btn-primary">Vissza a főoldalra</Link>
            </div>
          )}
        </>
      )}
      
      <div className="cart-cta">
        <Link to="/order" className="btn btn-secondary">Tovább a kosárhoz</Link>
      </div>
    </div>
  );
};

export default ProductsPage;
